import { UrlMatcher } from '@angular/router';

/** Placeholder used in tenant route templates, replaced by the current tenant id. */
export const TENANT_ID_PLACEHOLDER = ':tenantId';

const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const UUID_PATTERN = new RegExp(`^${UUID}$`, 'i');
const TENANT_URL_PATTERN = new RegExp(`^/tenant/(${UUID})(?:[/?#]|$)`, 'i');

/** Matches the `:tenantId` segment of `/tenant/:tenantId/...`, and only when it is a UUID. */
export const tenantIdMatcher: UrlMatcher = (segments) => {
  const [first] = segments;
  return first && UUID_PATTERN.test(first.path)
    ? { consumed: [first], posParams: { tenantId: first } }
    : null;
};

/** The tenant a URL is scoped to, or null outside `/tenant/:tenantId`. */
export function tenantIdFromUrl(url: string): string | null {
  return TENANT_URL_PATTERN.exec(url)?.[1]?.toLowerCase() ?? null;
}

/** Resolves a route template such as `/tenant/:tenantId/home`. */
export function tenantUrl(tenantId: string | null, template: string): string {
  return tenantId
    ? template.replace(TENANT_ID_PLACEHOLDER, tenantId)
    : template.replace(`/${TENANT_ID_PLACEHOLDER}`, '');
}
